<script>
    import { createUserAccount } from '/public/services/users/users';

	let member = {
		first_name: null,
		last_name: null,
		email: null,
		password: null
	}

    let created_account = false;

    function createAccount(e) {
        e.preventDefault();

        createUserAccount(member).then(res => {
            if (res.success === true) {
                created_account = true;
            }
        });
    }
</script>

<div class="card">
    <div class="card-header">
        Create Account
    </div>
    <div class="card-body">
        {#if created_account === false}
	    <form on:submit={createAccount}>
	        <div class="row mb-3">
                <label class="col-sm-3 col-form-label" for="first-name">
                    First name
                </label>
                <div class="col-sm-9">
                    <input id="first-name" type="text" class="form-control" required bind:value={member.first_name} placeholder="What is your first name?"/>
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-sm-3 col-form-label" for="last-name">
                    Last name
                </label>
                <div class="col-sm-9">
                    <input id="last-name" type="text" class="form-control" required bind:value={member.last_name} placeholder="What is your last name?"/>
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-sm-3 col-form-label" for="email">
                    Email
                </label>
                <div class="col-sm-9">
                    <input id="email" type="email" class="form-control" required bind:value={member.email} placeholder="What is your email address?"/>
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-sm-3 col-form-label" for="password">
                    Password
                </label>
                <div class="col-sm-9">
                    <input id="password" type="password" class="form-control" required bind:value={member.password} placeholder="Enter a password at least 8 chars in length"/>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-9 offset-sm-3">
                    <button type="submit" class="btn btn-success">
                        <span class="fas fa-plus-square"></span> Create Account
                    </button>
                </div>
            </div>
	    </form>
        {:else}
        <div class="alert alert-primary">
            <span class="fas fa-info-circle"></span> An account activation link will be arriving in your inbox shortly.
        </div>
        {/if}
    </div>
</div>
